<template>
  <el-card>
  <div>
  sdk 下载
  </div>
</el-card>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  }
};
</script>

<style scoped>
  .el-card {
    margin: 0 20px
  }
  
</style>
